<div class="page-header">
  <div class="row">
    <div class="col-sm-12">
      <ul class="breadcrumb">
        <li class="breadcrumb-item">
          <a [routerLink]="[rootRoute]">{{ rootLabel }}</a>
        </li>
        <!-- <li class="breadcrumb-item"><a href="#">{{ rootLabel }}</a></li> -->

        <li class="breadcrumb-item"><i class="feather icon-chevron-right"></i></li>
        <li class="breadcrumb-item active">{{ childLabel }}</li>

        <ng-content>
        </ng-content>
        <!-- <a [routerLink]="[c.url]">{{ c.label }}</a> -->

      </ul>
    </div>
  </div>
</div>